import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { API_ENDPOINTS } from '../../utils/config';
import HomeSkeleton from '../../components/skeleton/Skeleton';
import sectionGreyBg from '../../assets/images/bg_pattern.svg';
import sectionGreenBg from '../../assets/images/section-green.webp';

const Certification = () => {
    const [certifications, setCertifications] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const fetchCertifications = useCallback(async () => {
        setIsLoading(true);
        setHasError(false);
        try {
            const response = await axios.get(API_ENDPOINTS.CERTIFICATIONS_ENDPOINT, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
            });
            setCertifications(response.data || []);
        } catch (error) {
            console.error('Error fetching certifications:', error);
            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        document.body.classList.add('inner-page', 'certifications');
        fetchCertifications();

        return () => {
            document.body.classList.remove('inner-page', 'certifications');
        };
    }, [fetchCertifications]);

    const renderCertificationCard = (certification) => (
        <Col lg={4} md={6} sm={12} key={certification.id}>
            <div className="certification rounded-2 position-relative overflow-hidden">
                <div className="certification-image">
                    <img src={certification.image_url} alt={certification.title} loading="lazy" />
                </div>
                <h2 className="fw-500 text-5 text-dark">{certification.title}</h2>
                <p className="text-3 text-muted">{certification.excerpt}</p>
            </div>
        </Col>
    );

    return (
        <section
            id="certifications"
            className="section"
            style={{ backgroundImage: `url(${sectionGreyBg})` }}
        >
            <div
                className="section-decoration top"
                style={{ backgroundImage: `url(${sectionGreenBg})`, height: '35px' }}
            ></div>

            <Container>
                <Row className="g-4 text-center text-lg-start wowfadeInUp pt-5">
                    {isLoading && <HomeSkeleton type="certification" />}
                    {!isLoading && hasError && (
                        <Col>
                            <div className="alert alert-danger text-center">
                                Unable to load certifications. Please try again later.
                            </div>
                        </Col>
                    )}
                    {!isLoading && !hasError && certifications.length === 0 && (
                        <Col>
                            <div className="text-center text-muted">No certifications found.</div>
                        </Col>
                    )}
                    {!isLoading &&
                        !hasError &&
                        certifications.map(renderCertificationCard)}
                </Row>
            </Container>
        </section>
    );
};

export default Certification;
